import { render, staticRenderFns } from "./ConsultationsBlock.vue?vue&type=template&id=be58a28e&lang=pug&"
import script from "./ConsultationsBlock.vue?vue&type=script&lang=js&"
export * from "./ConsultationsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ConsultationsBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports